import { render, staticRenderFns } from "./TariffInfo.vue?vue&type=template&id=48d5d108&scoped=true&"
import script from "./TariffInfo.vue?vue&type=script&lang=js&"
export * from "./TariffInfo.vue?vue&type=script&lang=js&"
import style0 from "./TariffInfo.vue?vue&type=style&index=0&id=48d5d108&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d5d108",
  null
  
)

export default component.exports